

function isMobile() {
  return window.innerWidth <= 749;
}

function createCustomArrows(carousel, slides) {
  
  
  // Buscar las flechas que ya están en el HTML
  var hoverImagesContainer = carousel.closest('hover-images');
  if (!hoverImagesContainer) {
    
    return;
  }
  
  // Verificar que sea específicamente b-images
  if (!hoverImagesContainer.classList.contains('b-images')) {
    
    return;
  }
  
  var prevArrow = hoverImagesContainer.querySelector('.custom-mobile-prev');
  var nextArrow = hoverImagesContainer.querySelector('.custom-mobile-next');
  
  if (!prevArrow || !nextArrow) {
    
    return;
  }
  
  
  
  // Variables para el estado
  var currentSlide = 0;
  var totalSlides = slides.length;
  
  // Función para ir al slide
  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;
    
    currentSlide = index;
    
    slides.forEach(function(slide, i) {
      slide.style.display = i === currentSlide ? 'block' : 'none';
    });
    
    
  }
  
  // Limpiar event listeners anteriores
  var newPrevArrow = prevArrow.cloneNode(true);
  var newNextArrow = nextArrow.cloneNode(true);
  prevArrow.parentNode.replaceChild(newPrevArrow, prevArrow);
  nextArrow.parentNode.replaceChild(newNextArrow, nextArrow);
  
  // Event listeners
  newPrevArrow.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    goToSlide(currentSlide - 1);
  });
  
  newNextArrow.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    goToSlide(currentSlide + 1);
  });
  
  // Inicializar
  goToSlide(0);
  
  
}

function initializeFlickityCarousel(carousel, index) {
  
  
  if (!carousel || typeof Flickity === 'undefined') {
    
    return false;
  }

  try {
    // Destruir instancia existente si hay una
    var existingFlickity = Flickity.data(carousel);

if (existingFlickity) {
  return existingFlickity;
}

    // Crear nueva instancia con opciones específicas
    var flkty = new Flickity(carousel, {
      prevNextButtons: true,
      pageDots: false, // Desactivamos los dots nativos
      wrapAround: true,
      adaptiveHeight: true,
      draggable: true,
      autoPlay: false,
      cellSelector: '.product-item__bg__slide',
      contain: true
    });

    

    // Asegurar que los botones de navegación estén visibles
    if (flkty.prevButton) {
      flkty.prevButton.style.display = 'block';
      flkty.prevButton.style.opacity = '1';
      flkty.prevButton.style.visibility = 'visible';
      
    }
    if (flkty.nextButton) {
      flkty.nextButton.style.display = 'block';
      flkty.nextButton.style.opacity = '1';
      flkty.nextButton.style.visibility = 'visible';
      
    }

    // Agregar clase para indicar que Flickity está inicializado
    carousel.classList.add('flickity-initialized');
    
    return flkty;
  } catch (error) {
    
    return false;
  }
}



function findAndInitializeCarousels() {

  // Buscar SOLO los hover-images b-images con slider
  var hoverImages = document.querySelectorAll('hover-images.b-images');
 
  
  hoverImages.forEach(function(hoverImage, index) {
   
    var carousel = hoverImage.querySelector('.product-item__bg__slider');
  
    
    if (carousel) {
      // Verificar si tiene múltiples slides
      var slides = carousel.querySelectorAll('.product-item__bg__slide');

      if (slides.length > 1) {
        // Intentar inicializar Flickity primero
        var flickitySuccess = initializeFlickityCarousel(carousel, 'b-images-' + index);
        
        // Si es móvil y Flickity no funcionó, usar flechas personalizadas
        if (!flickitySuccess && isMobile()) {
         
          createCustomArrows(carousel, slides);
        }
      } else {
       
      }
    }
  });

  // También buscar carousels independientes (no en hover-images)
  var independentCarousels = document.querySelectorAll('.carousel, .flickity-ab-test');

  
  independentCarousels.forEach(function(carousel, index) {
    var slides = carousel.querySelectorAll('.product-item__bg__slide');
    if (slides.length > 1) {
      var flickitySuccess = initializeFlickityCarousel(carousel, 'independent-' + index);
      
      if (!flickitySuccess && isMobile()) {
       
        createCustomArrows(carousel, slides);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  
  findAndInitializeCarousels();
  
  // También inicializar después de un pequeño delay para elementos que se cargan dinámicamente
  setTimeout(function() {
   
    findAndInitializeCarousels();
  }, 500);
  
  // Tercer intento específico para móvil
  if (isMobile()) {
    setTimeout(function() {
      
      findAndInitializeCarousels();
    }, 1000);
  }
  
  // Observer para detectar cambios dinámicos
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var shouldReinitialize = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) { // Element node
              if (node.matches && (node.matches('hover-images.b-images') || node.querySelector && node.querySelector('hover-images.b-images'))) {
                shouldReinitialize = true;
                break;
              }
            }
          }
        }
      });
      
      if (shouldReinitialize) {
       
        setTimeout(findAndInitializeCarousels, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {

  function applyViewportClass() {
    document.querySelectorAll('.product-item__bg__slider.flickity-enabled').forEach(slider => {
      const viewports = slider.querySelectorAll('.flickity-viewport');
  
     
  
      if (viewports.length > 1) {
        
        // 1) Poner hidden a todos
        viewports.forEach(vp => vp.classList.add('hidden'));
  
        // 2) Quitar hidden al último
        const last = viewports[viewports.length - 1];
        last.classList.remove('hidden');
  
      }
    });
  }
  

  // 1) Intento inmediato
  applyViewportClass();

  // 2) Intento después de un frame por si Flickity tardó
  requestAnimationFrame(applyViewportClass);

  // 3) Intento extra después de un pequeño delay (garantizado)
  setTimeout(applyViewportClass, 200);

  // 4) Observer para carousels que cambien dinámicamente
  const observer = new MutationObserver(() => applyViewportClass());
  observer.observe(document.body, { childList: true, subtree: true });

});



/**
 * CHABACANO - Infinite Scroll Gallery Fix
 *
 * Solo agrega flechas a los productos cargados
 * mediante infinite scroll.
 *
 * No modifica las tarjetas iniciales.
 * No destruye Flickity.
 * No reinicializa Web Components.
 */

(function () {
  'use strict';

  if (window.chabacanoInfiniteGalleryFix) return;
  window.chabacanoInfiniteGalleryFix = true;

  const GALLERY_SELECTOR = 'hover-images.original-images';

  function initializeNewGallery(item) {
    const galleries = item.querySelectorAll(GALLERY_SELECTOR);

    galleries.forEach(function (gallery) {
      const slider = gallery.querySelector(
        '.product-item__bg__slider'
      );

      if (!slider) return;

      const slides = Array.from(
        slider.querySelectorAll('.product-item__bg__slide')
      );

      // No agregar flechas si hay una sola imagen
      if (slides.length <= 1) return;

      // Evitar duplicados
      if (
        gallery.querySelector('.custom-mobile-arrows') ||
        gallery.querySelector('.flickity-prev-next-button')
      ) {
        return;
      }

      const navigation = document.createElement('div');

      navigation.className =
        'custom-mobile-arrows chabacano-mobile-gallery-nav';

      navigation.innerHTML = `
        <button
          class="custom-mobile-arrow custom-mobile-prev"
          type="button"
          aria-label="Imagen anterior"
        >‹</button>

        <button
          class="custom-mobile-arrow custom-mobile-next"
          type="button"
          aria-label="Imagen siguiente"
        >›</button>
      `;

      gallery.appendChild(navigation);

      gallery.dataset.chabacanoCurrentSlide = '0';
    });
  }

  // Escuchar únicamente productos nuevos
  document.addEventListener(
    'chabacano:products:loaded',
    function (event) {
      const items = event.detail?.items || [];

      items.forEach(function (item) {
        initializeNewGallery(item);
      });
    }
  );

  // Delegación de eventos para nuevas flechas
  document.addEventListener(
    'click',
    function (event) {
      const arrow = event.target.closest(
        '.chabacano-mobile-gallery-nav .custom-mobile-arrow'
      );

      if (!arrow) return;

      const gallery = arrow.closest(GALLERY_SELECTOR);
      if (!gallery) return;

      const slider = gallery.querySelector(
        '.product-item__bg__slider'
      );

      if (!slider) return;

      const slides = Array.from(
        slider.querySelectorAll('.product-item__bg__slide')
      );

      if (slides.length <= 1) return;

      event.preventDefault();
      event.stopPropagation();

      const direction = arrow.classList.contains(
        'custom-mobile-next'
      ) ? 1 : -1;

      const currentSlide = Number(
        gallery.dataset.chabacanoCurrentSlide || 0
      );

      const nextSlide = (
        currentSlide + direction + slides.length
      ) % slides.length;

      gallery.dataset.chabacanoCurrentSlide =
        String(nextSlide);

      slides.forEach(function (slide, index) {
        const active = index === nextSlide;

        slide.style.display = active ? 'block' : 'none';
        slide.style.opacity = active ? '1' : '0';
        slide.style.visibility =
          active ? 'visible' : 'hidden';
      });
    },
    true
  );
})();


